import { render, staticRenderFns } from "./ReportAwardNominations.vue?vue&type=template&id=cc2824e4&v-if=isLoggedIn&"
import script from "./ReportAwardNominations.vue?vue&type=script&lang=js&"
export * from "./ReportAwardNominations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports